import type {
	FAQCategory,
	FAQCategoryWithQuestions,
	FAQQuestion,
} from "../types.js";

/**
 * Attaches the questions to the categories that they belong to.
 *
 * @param categories All of the categories.
 * @param questions All of the questions.
 * @returns An array of categories with their questions.
 */
export function attachQuestionsToCategories(
	categories: FAQCategory[],
	questions: FAQQuestion[],
): FAQCategoryWithQuestions[] {
	return categories.map((category) => {
		return {
			...category,
			questions: questions.filter(
				(question) => question.category_id === category.id,
			),
		};
	});
}
